import {
  Dices,
  Dog,
  Flame,
  Gamepad2,
  MoveHorizontal,
  PartyPopper,
  Puzzle,
  Target,
  Trees,
  Users,
  Wifi,
  type LucideIcon,
} from "lucide-react";
import { MaskReveal, Reveal } from "../Reveal";
import { ACTIVITY_GALLERY } from "./galleryData";

const AMENITIES: { icon: LucideIcon; label: string }[] = [
  { icon: Users, label: "Recreation Hall" },
  { icon: PartyPopper, label: "Meeting and Gathering Space" },
  { icon: Gamepad2, label: "Game Room" },
  { icon: MoveHorizontal, label: "Shuffleboard" },
  { icon: Dices, label: "Poker Table" },
  { icon: Target, label: "Dartboard" },
  { icon: Puzzle, label: "Board Games" },
  { icon: Trees, label: "Covered Picnic Area" },
  { icon: Flame, label: "Barbecue Pits" },
  { icon: Dog, label: "Off-Leash Pet Area" },
  { icon: Trees, label: "Outdoor Seating" },
  { icon: Wifi, label: "Wi-Fi" },
];

export function OnSiteRecreation() {
  const photo = ACTIVITY_GALLERY[12]!;

  return (
    <section
      className="bg-forest-deep py-24 text-cream sm:py-28 lg:py-32"
      aria-labelledby="recreation-title"
    >
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.15fr] lg:items-end lg:gap-20">
          <Reveal>
            <p className="eyebrow text-sand">On-Site Recreation</p>
            <h2
              id="recreation-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              Relax and Enjoy the Park
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-cream/80">
              Spend time indoors or out with gathering spaces and simple recreation that make longer
              stays and group visits more enjoyable.
            </p>
          </Reveal>

          <MaskReveal className="media-zoom rounded-sm">
            <img
              src={photo.src}
              srcSet={photo.srcSet}
              sizes="(min-width: 1024px) 50vw, 100vw"
              alt={photo.alt}
              width={photo.width}
              height={photo.height}
              loading="lazy"
              decoding="async"
              className="aspect-[16/9] w-full rounded-sm object-cover"
            />
          </MaskReveal>
        </div>

        <ul className="mt-16 grid gap-x-10 sm:grid-cols-2 lg:grid-cols-3">
          {AMENITIES.map((item, i) => (
            <Reveal as="li" key={item.label} delay={(i % 3) * 0.05}>
              <div className="flex items-center gap-4 border-b border-cream/15 py-5">
                <item.icon className="size-5 shrink-0 text-sand" aria-hidden="true" />
                <span className="text-sm font-medium leading-snug text-cream/95">{item.label}</span>
              </div>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
